import { render, staticRenderFns } from "./form-gated-text.vue?vue&type=template&id=f4eff848&scoped=true&"
import script from "./form-gated-text.vue?vue&type=script&lang=js&"
export * from "./form-gated-text.vue?vue&type=script&lang=js&"
import style0 from "./form-gated-text.vue?vue&type=style&index=0&id=f4eff848&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4eff848",
  null
  
)

export default component.exports